@if (history(); as selectedHistory) {
  <div class="zn-stand-history-modal-body">
    <section class="zn-stand-history-card zn-stand-history-card-summary">
      <div class="zn-stand-history-grid zn-stand-history-grid-main">
        <div class="zn-stand-history-field">
          <span class="zn-stand-history-label">{{ 'Geographic::Entity.FlowType' | abpLocalization }}</span>
          <strong class="zn-stand-history-value">
            {{ getNestedText(selectedHistory, ['flowType.name', 'flowTypeName']) }}
          </strong>
        </div>
        <div class="zn-stand-history-field">
          <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.FlowDate' | abpLocalization }}</span>
          <strong class="zn-stand-history-value">{{ formatDate(selectedHistory.flowDate) }}</strong>
        </div>
        <div class="zn-stand-history-field">
          <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.FlowUser' | abpLocalization }}</span>
          <strong class="zn-stand-history-value">
            {{ getNestedText(selectedHistory, ['flowUser.name', 'abpUsers.name', 'flowUserId']) }}
          </strong>
        </div>
      </div>

      <div class="zn-stand-history-description zn-stand-history-field">
        <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.Description' | abpLocalization }}</span>
        <p class="zn-stand-history-value">{{ selectedHistory.description || '-' }}</p>
      </div>
    </section>

    <section class="zn-stand-history-card">
      <h4 class="zn-stand-history-section-title">
        {{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionSectionTitle' | abpLocalization }}
      </h4>
      @if (!isInventoryEditMode()) {
        <div class="zn-stand-history-grid">
          <div class="zn-stand-history-field">
            <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionStatus' | abpLocalization }}</span>
            <strong class="zn-stand-history-value">
              {{ getNestedText(selectedHistory, ['inventoryDistributionStatus.name', 'inventoryDistributionStatusName', 'inventoryDistributionStatusId']) }}
            </strong>
          </div>
          <div class="zn-stand-history-field">
            <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionDate' | abpLocalization }}</span>
            <strong class="zn-stand-history-value">{{ formatDate(selectedHistory.inventoryDistributionDate) }}</strong>
          </div>
          <div class="zn-stand-history-field">
            <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionUser' | abpLocalization }}</span>
            <strong class="zn-stand-history-value">
              {{ getNestedText(selectedHistory, ['inventoryDistributionUserName', 'inventoryDistributionUser.userName', 'inventoryDistributionUserId']) }}
            </strong>
          </div>
        </div>

        <div class="zn-stand-history-description zn-stand-history-field">
          <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionComment' | abpLocalization }}</span>
          <p class="zn-stand-history-value">{{ selectedHistory.inventoryDistributionComment || '-' }}</p>
        </div>
      } @else {
        <form [formGroup]="form" class="zn-stand-history-form">
          <p class="zn-stand-history-helper">
            {{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionEditHelpText' | abpLocalization }}
          </p>

          <div class="zn-stand-history-form-grid">
            <div class="zn-stand-history-field">
              <label class="zn-stand-history-label" for="inventoryDistributionValue">
                {{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionStatus' | abpLocalization }}
              </label>
              <zn-single-select
                id="inventoryDistributionValue"
                [options]="distributionValueOptions"
                [showSearch]="false"
                [showClearSelection]="false"
                [placeholder]="'Geographic::Entity.StandTransformationHistory.InventoryDistributionSelectPlaceholder'"
                formControlName="inventoryDistributionValue"
              ></zn-single-select>
            </div>
          </div>

          <div class="zn-stand-history-field">
            <label class="zn-stand-history-label" for="inventoryDistributionComment">
              {{ 'Geographic::Entity.StandTransformationHistory.InventoryDistributionComment' | abpLocalization }}
            </label>
            <textarea
              id="inventoryDistributionComment"
              class="form-control zn-stand-history-textarea"
              [class.is-invalid]="form.controls.inventoryDistributionComment.hasError('maxlength')"
              rows="4"
              formControlName="inventoryDistributionComment"
              [placeholder]="'Geographic::Entity.StandTransformationHistory.InventoryDistributionCommentPlaceholder' | abpLocalization"
            ></textarea>
            @if (form.controls.inventoryDistributionComment.hasError('maxlength')) {
              <small class="invalid-feedback d-block">
                {{ distributionCommentMaxLengthMessageKey | abpLocalization : distributionCommentMaxLength }}
              </small>
            }
          </div>
        </form>
      }
    </section>

    <section class="zn-stand-history-card">
      <h4 class="zn-stand-history-section-title">
        {{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionSectionTitle' | abpLocalization }}
      </h4>
      @if (!isActivityEditMode()) {
        <div class="zn-stand-history-grid">
          <div class="zn-stand-history-field">
            <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionStatus' | abpLocalization }}</span>
            <strong class="zn-stand-history-value">
              {{ getNestedText(selectedHistory, ['activityDistributionStatus.name', 'activityDistributionStatusName', 'activityDistributionStatusId']) }}
            </strong>
          </div>
          <div class="zn-stand-history-field">
            <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionDate' | abpLocalization }}</span>
            <strong class="zn-stand-history-value">{{ formatDate(selectedHistory.activityDistributionDate) }}</strong>
          </div>
          <div class="zn-stand-history-field">
            <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionUser' | abpLocalization }}</span>
            <strong class="zn-stand-history-value">
              {{ getNestedText(selectedHistory, ['activityDistributionUserName', 'activityDistributionUser.userName', 'activityDistributionUserId']) }}
            </strong>
          </div>
        </div>

        <div class="zn-stand-history-description zn-stand-history-field">
          <span class="zn-stand-history-label">{{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionComment' | abpLocalization }}</span>
          <p class="zn-stand-history-value">{{ selectedHistory.activityDistributionComment || '-' }}</p>
        </div>
      } @else {
        <form [formGroup]="form" class="zn-stand-history-form">
          <p class="zn-stand-history-helper">
            {{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionEditHelpText' | abpLocalization }}
          </p>

          <div class="zn-stand-history-form-grid">
            <div class="zn-stand-history-field">
              <label class="zn-stand-history-label" for="activityDistributionValue">
                {{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionStatus' | abpLocalization }}
              </label>
              <zn-single-select
                id="activityDistributionValue"
                [options]="distributionValueOptions"
                [showSearch]="false"
                [showClearSelection]="false"
                [placeholder]="'Geographic::Entity.StandTransformationHistory.InventoryDistributionSelectPlaceholder'"
                formControlName="activityDistributionValue"
              ></zn-single-select>
            </div>
          </div>

          <div class="zn-stand-history-field">
            <label class="zn-stand-history-label" for="activityDistributionComment">
              {{ 'Geographic::Entity.StandTransformationHistory.ActivityDistributionComment' | abpLocalization }}
            </label>
            <textarea
              id="activityDistributionComment"
              class="form-control zn-stand-history-textarea"
              [class.is-invalid]="form.controls.activityDistributionComment.hasError('maxlength')"
              rows="4"
              formControlName="activityDistributionComment"
              [placeholder]="'Geographic::Entity.StandTransformationHistory.ActivityDistributionCommentPlaceholder' | abpLocalization"
            ></textarea>
            @if (form.controls.activityDistributionComment.hasError('maxlength')) {
              <small class="invalid-feedback d-block">
                {{ distributionCommentMaxLengthMessageKey | abpLocalization : distributionCommentMaxLength }}
              </small>
            }
          </div>
        </form>
      }
    </section>

    @if (loading()) {
      <div class="zn-stand-history-loading">
        {{ 'Geographic::Entity.StandTransformationHistory.LoadingDetail' | abpLocalization }}
      </div>
    }
  </div>
}
